<form [formGroup]="formGroup" class="program-checkbox card">
  <h4>{{ programNode?.labelText }}</h4>
  <span
    class="label-highlight"
    *ngIf="programNode?.description"
    [innerHTML]="programNode?.description"
  ></span>
  <div formArrayName="options" class="program-checkbox__options">
    <ng-container *ngFor="let item of programNode?.values; let i = index">
      <mat-checkbox [formControlName]="i" [disabled]="isCheckboxDisabled(i)">
        {{ item.label || item.name }}
      </mat-checkbox>
    </ng-container>
    <mat-checkbox
      *ngIf="programNode?.allAboveDescription"
      [checked]="isAllAboveChecked"
      (change)="selectAllAbove($event)"
    >
      {{ programNode?.allAboveDescription }}
    </mat-checkbox>
    <mat-checkbox
      *ngIf="programNode?.noneAboveDescription"
      [checked]="isNoneAboveChecked"
      (change)="selectNoneAbove($event)"
    >
      {{ programNode?.noneAboveDescription }}
    </mat-checkbox>
  </div>
</form>
